export default __webpack_public_path__ + "static/img-6-0174d2e5edf5ee2407cb7ac4cab49d97.png";